import { useState, useEffect } from "react";
import { RegisterLink } from "@/components/RegisterLink";

const LOGO = "https://xt30sf.b-cdn.net/media/b1c35ec0b8d96f3dde3fa.png";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [bonusOpen, setBonusOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navLinks = [
    { label: "Slots", section: "header_nav" },
    { label: "Bonus", section: "header_nav", dropdown: true },
    { label: "Live Casino", section: "header_nav" },
    { label: "Specials", section: "header_nav" },
    { label: "App", section: "header_nav" },
    { label: "Payments", section: "header_nav" },
  ];

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
          scrolled
            ? "glass-card border-b border-[#c9a84c]/10"
            : "bg-transparent border-b border-transparent"
        }`}
      >
        <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between h-18 py-4">
          {/* Logo */}
          <a href="/" className="flex items-center group">
            <img
              src={LOGO}
              alt="Rolex9"
              className="h-10 w-auto object-contain"
            />
          </a>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8">
            {navLinks.map((link) =>
              link.dropdown ? (
                <div key={link.label} className="relative">
                  <button
                    className="text-white/60 hover:text-[#c9a84c] transition-colors text-xs font-medium flex items-center gap-1 cursor-pointer tracking-widest uppercase"
                    onClick={() => setBonusOpen(!bonusOpen)}
                  >
                    {link.label}
                    <i className={`ri-arrow-down-s-line transition-transform ${bonusOpen ? "rotate-180" : ""}`}></i>
                  </button>
                  {bonusOpen && (
                    <div className="absolute top-full left-0 mt-3 glass-card rounded-xl py-2 min-w-[180px] z-50">
                      <RegisterLink section="header_nav" label="Welcome Bonus" className="block px-5 py-2.5 text-xs text-white/60 hover:text-[#c9a84c] tracking-widest uppercase transition-colors" onClick={() => setBonusOpen(false)}>Welcome Bonus</RegisterLink>
                      <RegisterLink section="header_nav" label="Daily Rebate" className="block px-5 py-2.5 text-xs text-white/60 hover:text-[#c9a84c] tracking-widest uppercase transition-colors" onClick={() => setBonusOpen(false)}>Daily Rebate</RegisterLink>
                      <RegisterLink section="header_nav" label="Deposit Ranking" className="block px-5 py-2.5 text-xs text-white/60 hover:text-[#c9a84c] tracking-widest uppercase transition-colors" onClick={() => setBonusOpen(false)}>Deposit Ranking</RegisterLink>
                    </div>
                  )}
                </div>
              ) : (
                <RegisterLink
                  key={link.label}
                  section={link.section}
                  label={link.label}
                  className="text-white/60 hover:text-[#c9a84c] transition-colors text-xs font-medium tracking-widest uppercase"
                >
                  {link.label}
                </RegisterLink>
              )
            )}
          </nav>

          {/* Buttons */}
          <div className="hidden md:flex items-center gap-3">
            <RegisterLink section="header" label="Log In" className="btn-outline-gold px-5 py-2 rounded-lg text-xs">
              Log In
            </RegisterLink>
            <RegisterLink section="header" label="Register" className="btn-glow px-6 py-2 rounded-lg text-xs">
              Register
            </RegisterLink>
          </div>

          {/* Mobile hamburger */}
          <button
            className="md:hidden text-white/70 cursor-pointer"
            onClick={() => setMenuOpen(true)}
          >
            <i className="ri-menu-3-line text-xl"></i>
          </button>
        </div>
      </header>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="fixed inset-0 z-[100] flex">
          <div
            className="w-80 h-full flex flex-col p-8 overflow-y-auto"
            style={{
              background: "linear-gradient(160deg, rgba(3,7,33,0.98) 0%, rgba(10,5,40,0.98) 100%)",
              borderRight: "1px solid rgba(201,168,76,0.15)",
            }}
          >
            <div className="flex items-center justify-between mb-10">
              <img src={LOGO} alt="Rolex9" className="h-9 w-auto object-contain" />
              <button onClick={() => setMenuOpen(false)} className="text-white/50 hover:text-white cursor-pointer">
                <i className="ri-close-line text-xl"></i>
              </button>
            </div>
            <div className="flex flex-col gap-3 mb-8">
              <RegisterLink section="header_mobile" label="Register" className="btn-glow py-3 rounded-xl text-xs w-full text-center">Register</RegisterLink>
              <RegisterLink section="header_mobile" label="Log In" className="btn-outline-gold py-3 rounded-xl text-xs w-full text-center">Log In</RegisterLink>
            </div>
            <div className="light-line mb-8"></div>
            <nav className="flex flex-col gap-1">
              {navLinks.map((link) => (
                <RegisterLink
                  key={link.label}
                  section="header_mobile_nav"
                  label={link.label}
                  className="text-white/50 hover:text-[#c9a84c] text-xs tracking-widest uppercase py-3 border-b border-white/5 transition-colors"
                  onClick={() => setMenuOpen(false)}
                >
                  {link.label}
                </RegisterLink>
              ))}
            </nav>
          </div>
          <button
            type="button"
            aria-label="Close menu"
            className="flex-1 bg-black/70 backdrop-blur-sm"
            onClick={() => setMenuOpen(false)}
          ></button>
        </div>
      )}
    </>
  );
}
